var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPossuiEletrecidade = function SvgPossuiEletrecidade(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.57 15H7.438C7.17194 14.5208 6.9026 14.0435 6.63 13.568C5.526 11.628 5 10.206 5 8.5C5 4.655 8.192 2 11.997 2C15.803 2 19 4.658 19 8.5C19 10.205 18.47 11.641 17.366 13.586C17.021 14.194 16.763 14.649 16.569 15H16.57ZM15.987 17C15.899 20.412 14.829 21.99 11.997 21.99C9.172 21.99 8.095 20.393 8.007 17H15.987ZM15.003 10C15.999 10 15.999 9 15.999 9C15.999 7.93913 15.5776 6.92172 14.8274 6.17157C14.0773 5.42143 13.0599 5 11.999 5C11.999 5 11 5.001 11 6C11 6.999 12 6.999 12 6.999C13.08 6.999 14 7.875 14 9C14 9 14.006 10 15.003 10Z",
    fill: "#3A3A47"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPossuiEletrecidade, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/possui-eletrecidade.dbd360c9.svg";
export { ForwardRef as ReactComponent };